export var checkPlayerHasEnoughGold = function (path) { return function (action) {
    var requiredGold = action.requiredGold, playerGold = action.playerGold;
    if (playerGold.lessThan(requiredGold)) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/checkPlayerHasEnoughGold.ts
// module id = 1789
// module chunks = 3